module.exports = __webpack_public_path__ + "static/media/ic-person.83544422.svg";